import t from 'react-translate';
import { useSelector } from 'react-redux';
import AiGenerationPreview from '../../ai-config-modal/ai-scenario-generating-preview';
import RolePlayFeedback from './roleplay-feedback';

type AiFeedbackProps = {
  submissionId?: number;
};
const AiFeedback = (props: AiFeedbackProps) => {
  const { submissionId } = props;
  const submission = useSelector((state) => (submissionId ? state.models.aiRolePlaySubmissions[submissionId] : null));
  const aiGenerationTexts = [
    t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.REVIEWING_CONVERSATION(),
    t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.COMPARING_LEARNER_GOALS(),
    t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.PREPARING_FEEDBACK(),
  ];

  const feedback = submission?.feedback;

  const {
    evaluation,
    overallSummary,
    whereYouDidWell,
    whereYouCanGrow,
  } = feedback || {};

  if (feedback) {
    return (
      <RolePlayFeedback
        evaluation={evaluation}
        overallSummary={overallSummary}
        whereYouDidWell={whereYouDidWell}
        whereYouCanGrow={whereYouCanGrow}
      />
    );
  }
  return (
    <div className='w-100'>
      <AiGenerationPreview
        aiGenerationTexts={aiGenerationTexts}
      />
    </div>
  );
};

export default AiFeedback;
